import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import DataContext from "../../../../context/users/DataContextCopy";
import { FormLabel } from "react-bootstrap";
import { useEffect } from "react";

function PwCheckPopup({ open, handleClose }) {
  const { userPwdCheck, setUserPwdCheck, UserSecretCheck, setSeqno } =
    useContext(DataContext);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: window.innerWidth < 600 ? "80%" : "40%",
    height: window.innerWidth < 600 ? "90vh" : 700,
    bgcolor: "background.paper",
    border: "2px solid #0075c1",
    boxShadow: 24,
    p: 4,
  };

  const navigate = useNavigate();

  const handleButtonClick = async () => {
    const detailRes = await UserSecretCheck();
    if (detailRes) {
      setSeqno(detailRes.mw_id);
      navigate("/declarelist/answer");
    } else {
      alert("비밀번호를 다시 확인해 주세요.");
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    setUserPwdCheck(e.target.value);
  };



  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleButtonClick();
    }
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
          setUserPwdCheck('');
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <div
            style={{
              width: '98%',
              height: '7vh',
              backgroundColor: '#0075c1',
              textAlign: 'center',
              borderRadius: '10px',
            }}
          >
            <h2 style={{ color: 'white', paddingTop: '2vh' }}>사용자 확인</h2>
          </div>

          <div style={{ marginTop: '1vh', width: '100%', height: '100%' }}>
            <FormLabel htmlFor='hiddenField'>비밀번호*</FormLabel>
            <TextField
              type='password'
              id='hiddenField'
              name='hiddenField'
              fullWidth
              sx={{ textAlign: 'center' }}
              helperText='민원신고시, 등록한 비밀번호를 입력해주세요.'
              value={userPwdCheck}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />

            <Button variant='contained' type={'submit'} color={'info'} fullWidth sx={{ marginTop: 1 }} onClick={handleButtonClick}>
              확인
            </Button>
            <Button
              variant='contained'
              color={'inherit'}
              fullWidth
              sx={{ marginTop: 1 }}
              onClick={() => {
                handleClose();
                setUserPwdCheck('');
              }}
            >
              돌아가기
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default PwCheckPopup;
